/**
 * Аллергены блюда (вопрос 30, вариант А: поле в базе + значки в карточке товара).
 *
 * В базе (products.allergens) лежит строка кодов через запятую: 'fish,sesame,soy'.
 * Словарь кодов обязан совпадать с серверным — azia_back/azia_back/utils/allergens.js.
 *
 * Пустое поле — это НЕ «аллергенов нет», а «не размечено»: карточка в таком случае
 * показывает общую оговорку, а не обещание безопасности. Для доставки суши
 * (рыба, ракообразные, кунжут, глютен) это принципиальная разница.
 */

export interface AllergenInfo {
  code: string;
  /** Подпись под значком */
  label: string;
  /** Эмодзи для админки; на сайте значок рисует AllergenIcon из нашего набора иконок */
  icon: string;
}

export const ALLERGENS: readonly AllergenInfo[] = [
  { code: 'fish', label: 'Рыба', icon: '🐟' },
  { code: 'crustaceans', label: 'Ракообразные', icon: '🦐' },
  { code: 'molluscs', label: 'Моллюски', icon: '🦑' },
  { code: 'gluten', label: 'Глютен', icon: '🌾' },
  { code: 'sesame', label: 'Кунжут', icon: '🌰' },
  { code: 'soy', label: 'Соя', icon: '🫘' },
  { code: 'egg', label: 'Яйцо', icon: '🥚' },
  { code: 'milk', label: 'Молоко', icon: '🥛' },
  { code: 'nuts', label: 'Орехи', icon: '🥜' },
  { code: 'peanuts', label: 'Арахис', icon: '🥜' },
] as const;

const BY_CODE = new Map(ALLERGENS.map((item) => [item.code, item]));

/**
 * Разбирает значение из базы в список известных аллергенов.
 * Неизвестные коды молча выбрасываются: значок без подписи хуже, чем его отсутствие.
 */
export function parseAllergens(value?: string | string[] | null): AllergenInfo[] {
  if (!value) return [];

  const codes = Array.isArray(value) ? value : value.split(',');

  const result: AllergenInfo[] = [];
  for (const raw of codes) {
    const code = String(raw || '').trim().toLowerCase();
    if (!code) continue;
    const info = BY_CODE.get(code);
    if (info && !result.includes(info)) result.push(info);
  }

  return result;
}
